import React from 'react';
import BannerImage from '../../images/500.png';
import './Banner1.css';

const Banner2 = () => {
  return (
    <div className="banner-container">
      <img src="https://snitch.co.in/cdn/shop/files/1_7bd18f46-c71d-47ab-b852-483ca2a78d70.jpg?v=1682766806&width=1600" alt="50% Off Banner" className="banner-image" />
        </div>
  );
}

export default Banner2;
